import React from "react";

/**
 * Reusable "Domestic $X · International $Y CAD" chip used on program cards
 * and the public detail page so the two tuition tiers are always obvious.
 * Falls back to a single "$X CAD" when no international fee is set.
 */
export default function TuitionBadge({
    domestic,
    international,
    className = "",
    compact = false,
    testId,
}) {
    const dom = Number(domestic || 0);
    const hasIntl =
        international !== null &&
        international !== undefined &&
        Number(international) > 0;
    if (!hasIntl) {
        return (
            <span
                className={className}
                data-testid={testId || "tuition-single"}
            >
                ${dom.toFixed(2)} CAD
            </span>
        );
    }
    if (compact) {
        return (
            <span
                className={className}
                data-testid={testId || "tuition-compact"}
            >
                ${dom.toFixed(2)}{" "}
                <span className="text-muted-foreground">·</span>{" "}
                ${Number(international).toFixed(2)} CAD
            </span>
        );
    }
    return (
        <span
            className={`inline-flex flex-wrap items-center gap-x-3 gap-y-0.5 ${className}`}
            data-testid={testId || "tuition-dual"}
        >
            <span>
                <span className="text-xs uppercase tracking-[0.14em] text-muted-foreground mr-1">
                    Domestic
                </span>
                ${dom.toFixed(2)}
            </span>
            <span>
                <span className="text-xs uppercase tracking-[0.14em] text-muted-foreground mr-1">
                    International
                </span>
                ${Number(international).toFixed(2)}
            </span>
            <span className="text-xs text-muted-foreground">CAD</span>
        </span>
    );
}
